module.exports = __webpack_public_path__ + "static/4-1b6dd7b19d8f43290ff1b3942cf557ee.jpeg";